export default __webpack_public_path__ + "static/media/404.ceb28db3.svg";